import AppVersion from './appVersion' //app版本
import BasicConfiguration from './basicConfiguration' //基础配置
import OperationLog from './operationLog' // 操作日志
import PlatformPermissions from './platformPermissions' //平台权限

//系统
export default [
    {
        path: 'system',
        name: 'system',
        meta: {
            title: '系统',
            icon: 'system'
        },
        hidden: false,
        component: () => import("@/views/system/index.vue"),
        children:[
            ...PlatformPermissions,
            ...AppVersion,
            ...BasicConfiguration,
            ...OperationLog
        ]
    }

]